import { useEffect, useMemo, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardDescription,
  CardTitle,
  Divider,
  Halo,
  Input,
  Modal,
  Navbar,
  Reveal,
  Section,
  ThemeToggle,
  aplicarTemaRenke,
  temaRenkeSalvo,
} from "@base/ui/renke";

/**
 * Pagina de demonstracao do Renke Design System.
 * Rota publica: #/design-system
 */
export function PaginaDesignSystem() {
  const [modalAberto, definirModal] = useState(false);
  const [email, definirEmail] = useState("");

  useEffect(() => {
    aplicarTemaRenke(temaRenkeSalvo());
  }, []);

  const links = useMemo(
    () => [
      { href: "#primitivos", rotulo: "Primitivos", atual: true },
      { href: "#superficies", rotulo: "Superfícies" },
      { href: "#nav", rotulo: "Nav" },
    ],
    [],
  );

  return (
    <div className="rk-surface" style={{ minHeight: "100dvh" }}>
      <Navbar
        marca={<span>Renke DS</span>}
        links={links}
        acoes={
          <>
            <ThemeToggle />
            <Button variante="brand" tamanho="sm">
              CTA único
            </Button>
          </>
        }
      />

      <Halo pulse>
        <Section
          hero
          tom="canvas"
          alinhamento="center"
          eyebrow="Renke Design System"
          titulo="Preto absoluto. Amarelo como evento."
          lead="Biblioteca tipada alinhada ao design-system.json: tokens --rk-*, tema dark por padrão, linguagem visual Apple."
        >
          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button variante="primary" tamanho="lg">
              Primário
            </Button>
            <Button variante="secondary" tamanho="lg">
              Secundário
            </Button>
          </div>
        </Section>
      </Halo>

      <Section
        id="primitivos"
        tom="subtle"
        eyebrow="Primitivos"
        titulo="Botões, input e badges"
        lead="Primário troca de cor por tema. Brand amarelo: no máximo um por viewport."
      >
        <Reveal>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 32 }}>
            {(["primary", "brand", "secondary", "ghost", "link"] as const).map(
              (v) => (
                <Button key={v} variante={v} tamanho="md">
                  {v}
                </Button>
              ),
            )}
            <Button carregando tamanho="md">
              Loading
            </Button>
          </div>
        </Reveal>
        <Reveal delayMs={80}>
          <div style={{ maxWidth: 400, marginBottom: 24 }}>
            <Input
              rotulo="E-mail"
              placeholder="você@clinica.com"
              value={email}
              onChange={(e) => definirEmail(e.target.value)}
              auxiliar="Nunca use amarelo 500 como texto sobre branco."
            />
          </div>
        </Reveal>
        <Reveal delayMs={160}>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <Badge variante="brand">Brand</Badge>
            <Badge variante="neutral">Neutral</Badge>
            <Badge variante="success">Success</Badge>
          </div>
        </Reveal>
      </Section>

      <Section
        id="superficies"
        tom="canvas"
        eyebrow="Superfícies"
        titulo="Cards e divisores"
      >
        <div
          style={{
            display: "grid",
            gap: 24,
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          }}
        >
          <Reveal>
            <Card interativo>
              <CardTitle>Card padrão</CardTitle>
              <CardDescription>
                No dark, profundidade por luminância + borda sutil.
              </CardDescription>
            </Card>
          </Reveal>
          <Reveal delayMs={80}>
            <Card featured>
              <CardTitle>Card featured</CardTitle>
              <CardDescription>
                Borda brand + brandGlow. Um destaque por seção.
              </CardDescription>
            </Card>
          </Reveal>
        </div>
        <div style={{ marginTop: 40 }}>
          <Divider />
          <div style={{ height: 24 }} />
          <Divider brand />
        </div>
      </Section>

      <Section id="nav" tom="subtle" eyebrow="Overlays" titulo="Modal">
        <Button variante="secondary" onClick={() => definirModal(true)}>
          Abrir modal
        </Button>
        <Modal
          aberto={modalAberto}
          titulo="Exemplo de modal"
          descricao="Backdrop com blur, painel elevated, Escape fecha."
          onFechar={() => definirModal(false)}
        />
      </Section>

      <Section tom="canvas">
        <p className="rk-caption" style={{ color: "var(--rk-text-tertiary)" }}>
          Fonte: design-system/design-system.json · brand.500 é a única fonte do
          amarelo.
        </p>
      </Section>
    </div>
  );
}
